import { render } from "./CompanyResult.vue?vue&type=template&id=580334c9"
import script from "./CompanyResult.vue?vue&type=script&lang=js"
export * from "./CompanyResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__